import { z } from 'zod';
import * as FlatModels from '../../internal';

export const AlertType = z.enum([
  'error',
  'warn',
  'success',
  'info',
]);
export type AlertType = z.infer<typeof AlertType>;

export const AlertSeverityIconSchema = z.record(z.string(), z.nativeEnum(FlatModels.ButtonDesignModels.ButtonDefaultIcons));

export const AlertSeverityIcon: z.infer<typeof AlertSeverityIconSchema> = {
  [AlertType.enum.error]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.ERROR,
  [AlertType.enum.warn]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.WARNING,
  [AlertType.enum.success]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.INFO,
  [AlertType.enum.info]: FlatModels.ButtonDesignModels.ButtonDefaultIcons.INFO,
}

export enum AlertTime {
  ENDLESS = 43200000,
  DEFAULT = 2000,
  SUCCESS = 4000,
}

export const AlertOptionsSchema = z.object({
  message: z.string().optional(),
  params: z.any().optional(),
  type: AlertType.optional(),
  code: z.number().optional(),
  dismissible: z.boolean().optional(),
  duration: z.number().optional(),
});

export type AlertOptions = z.infer<typeof AlertOptionsSchema>;

export const AlertSchema = z.object({
  id: z.string().uuid(),
  timestamp: z.coerce.date(),
  message: z.string(),
  params: z.any(),
  type: AlertType,
  code: z.number(),
  dismissible: z.boolean().optional(),
  duration: z.number().optional(),
  dismissed: z.boolean().optional(),
});

export type Alert = z.infer<typeof AlertSchema>;
